import React from 'react';

function About() {
  return (
    <section className="section about" id="about">
      <div className="section-header">
        <h2>About Windy Hill Weavers</h2>
        <div className="section-divider" />
      </div>
      <div className="about-content">
        <div className="about-image">
          <img src="/images/hero/3rugs_me_loom8x10_crop.jpg" alt="Kathy Marty at her loom" />
        </div>
        <div className="about-text">
          <p>
            Since I was a child, I've been fascinated by textiles, and have avidly collected
            them on my travels to Mexico, Japan, Nepal, and Greece. I learned to weave in
            college, and in 1979, I went to Japan for four months to study the art of silk
            kimono weaving, Kasuri (tying and dyeing threads in intricate patterns, then
            weaving them), and natural indigo dyeing.
          </p>
          <p>
            I am fortunate to live in Washougal, WA, a small town in the Columbia River Gorge
            and home to Pendleton<sup>&copy;</sup> Woolen Mills, a creator of iconic American blankets,
            clothing, and textiles since 1912. When Pendleton<sup>&copy;</sup> weaves their blankets, it
            trims narrow strips from their edges before hemming. These strips are called
            &ldquo;selvage.&rdquo;
          </p>
          <p>
            Using two antique looms, I recycle this selvage, weaving it into eco-friendly
            reversible area rugs. The vibrant colors, rich textures, and fine quality of
            Pendleton<sup>&copy;</sup> wool give each rug a brilliant look and a thick, luxurious feel,
            and inspire me to continually explore new patterns and styles. I've recently begun
            to weave my rugs into semi-abstract natural landscapes, inspired by the beautiful
            Cascade Mountain foothills and the magnificent Columbia River.
          </p>
          <p>
            My passion is to brighten homes with beautiful, durable, and environmentally
            sustainable handwoven rugs and other home d&eacute;cor made from Pendleton<sup>&copy;</sup>
            wool remnants and fabric. Come see my work at an art show in Washington or Oregon,
            or contact me for a custom order!
          </p>
          <p className="about-signature">&ndash; Kathy Marty</p>
        </div>
      </div>
    </section>
  );
}

export default About;
